(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-ceramic-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const validSeries = new Set(['all', 'cafe', 'table', 'cadeaux']);
  const validTypes = {
    cafe: new Set(['tasses-gobelets', 'tasses-soucoupes', 'bols', 'plats-service']),
    table: new Set(['bols', 'assiettes', 'plats-service']),
    cadeaux: new Set(['tasses-gobelets', 'tasses-soucoupes', 'bols', 'assiettes', 'plats-service'])
  };

  document.querySelectorAll('[data-ox-series-catalog]').forEach((root) => {
    if (root.dataset.oxCatalogReady === 'true') return;
    root.dataset.oxCatalogReady = 'true';

    const seriesButtons = [...root.querySelectorAll('[data-ox-series-filter]')];
    const typeButtons = [...root.querySelectorAll('[data-ox-type-filter]')];
    const typeGroups = [...root.querySelectorAll('[data-ox-type-group]')];
    const cards = [...root.querySelectorAll('[data-ox-catalog-card]')];
    const count = root.querySelector('[data-ox-catalog-count]');
    const empty = root.querySelector('[data-ox-catalog-empty]');
    let state = { series: 'all', type: '' };

    const readUrl = () => {
      const params = new URL(window.location.href).searchParams;
      const requestedSeries = params.get('series') || 'all';
      const series = validSeries.has(requestedSeries) ? requestedSeries : 'all';
      const requestedType = params.get('type') || '';
      const type = series !== 'all' && validTypes[series].has(requestedType) ? requestedType : '';
      return { series, type };
    };

    const writeUrl = () => {
      const url = new URL(window.location.href);
      if (state.series === 'all') {
        url.searchParams.delete('series');
        url.searchParams.delete('type');
      } else {
        url.searchParams.set('series', state.series);
        if (state.type) url.searchParams.set('type', state.type);
        else url.searchParams.delete('type');
      }
      window.history.replaceState({}, '', url);
    };

    const applyState = (nextState, updateUrl = false) => {
      const series = validSeries.has(nextState.series) ? nextState.series : 'all';
      const type = series !== 'all' && validTypes[series].has(nextState.type) ? nextState.type : '';
      state = { series, type };

      seriesButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.seriesValue === series));
      });
      typeButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.typeValue === type));
      });
      typeGroups.forEach((group) => {
        group.hidden = group.dataset.seriesGroup !== series;
      });

      let visibleCount = 0;
      cards.forEach((card) => {
        const seriesValues = (card.dataset.oxSeries || '').split(/\s+/).filter(Boolean);
        const typeValues = (card.dataset.oxTypes || '').split(/\s+/).filter(Boolean);
        const visible = (series === 'all' || seriesValues.includes(series)) && (!type || typeValues.includes(type));
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (count) count.textContent = String(visibleCount);
      if (empty) empty.hidden = visibleCount !== 0;
      if (updateUrl) writeUrl();
    };

    seriesButtons.forEach((button) => {
      button.addEventListener('click', () => applyState({ series: button.dataset.seriesValue, type: '' }, true));
    });
    typeButtons.forEach((button) => {
      button.addEventListener('click', () => applyState({ series: state.series, type: button.dataset.typeValue }, true));
    });
    window.addEventListener('popstate', () => applyState(readUrl()));
    applyState(readUrl());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-ceramic-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-orienx-home]');
    if (!root) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const reveals = root.querySelectorAll('[data-ox-reveal]');
    if (!reduced && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= .08) {
            entry.target.classList.add('is-visible');
            return;
          }
          if (entry.isIntersecting) return;

          entry.target.classList.remove('is-visible');
          if (entry.target.matches('.ox-craft__scene')) return;

          if (entry.boundingClientRect.bottom <= 0) {
            entry.target.style.setProperty('--ox-reveal-y','-24px');
          } else if (entry.boundingClientRect.top >= window.innerHeight) {
            entry.target.style.setProperty('--ox-reveal-y','24px');
          }
        });
      }, { threshold:[0,.08], rootMargin:'0px' });
      reveals.forEach((item) => observer.observe(item));
    } else reveals.forEach((item) => item.classList.add('is-visible'));



    if (!reduced && window.matchMedia('(pointer:fine)').matches) {
      const applyMagnetic = (element,strength = 8) => {
        if (!element) return;
        element.addEventListener('pointermove',(event) => {
          const rect = element.getBoundingClientRect();
          element.style.setProperty('--mag-x',`${(event.clientX - rect.left - rect.width / 2) / strength}px`);
          element.style.setProperty('--mag-y',`${(event.clientY - rect.top - rect.height / 2) / strength}px`);
        });
        element.addEventListener('pointerleave',() => {
          element.style.setProperty('--mag-x','0px');
          element.style.setProperty('--mag-y','0px');
        });
      };
      root.querySelectorAll('[data-ox-magnetic]').forEach((element) => applyMagnetic(element,9));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-community-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const root=document.querySelector('[data-ox-community]');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=root.querySelectorAll('[data-community-reveal],.ox-community-fragment');
    if(!reduced&&'IntersectionObserver'in window){
      root.classList.add('ox-community-motion');
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');observer.unobserve(entry.target)}),{threshold:.06,rootMargin:'0px 0px -5%'});
      reveals.forEach((item,index)=>{if(item.classList.contains('ox-community-fragment'))item.style.transitionDelay=`${Math.min(index%6,5)*52}ms`;observer.observe(item)});
    }else reveals.forEach(item=>item.classList.add('is-visible'));
    const dialog=root.querySelector('[data-community-dialog]');
    const image=root.querySelector('[data-community-image]');
    const copy=root.querySelector('[data-community-copy]');
    const close=()=>dialog?.close();
    root.querySelectorAll('[data-community-open]').forEach(button=>button.addEventListener('click',()=>{if(!dialog||!image)return;image.src=button.dataset.communitySrc||'';image.alt=button.dataset.communityCaption||'Fragment de la communauté OrienX';if(copy)copy.textContent=button.dataset.communityCaption||'';dialog.showModal()}));
    root.querySelector('[data-community-close]')?.addEventListener('click',close);
    dialog?.addEventListener('click',event=>{if(event.target===dialog)close()});
    dialog?.addEventListener('cancel',event=>{event.preventDefault();close()});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-editorial-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-orienx-maison-page]');
    if (!root) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = root.querySelectorAll('[data-maison-reveal],.orienx-fragment');
    if (!reduced && 'IntersectionObserver' in window) {
      root.classList.add('maison-motion-ready');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold:.06, rootMargin:'0px 0px -5% 0px' });
      revealItems.forEach((item,index) => {
        if (item.classList.contains('orienx-fragment')) item.style.transitionDelay = `${Math.min(index % 6,5) * 55}ms`;
        observer.observe(item);
      });
    } else revealItems.forEach((item) => item.classList.add('is-visible'));

    const filmDialog = root.querySelector('[data-film-dialog]');
    const filmPlayer = root.querySelector('[data-film-player]');
    const filmClose = root.querySelector('[data-film-close]');
    const closeFilm = () => { filmPlayer?.pause(); filmDialog?.close(); };
    root.querySelectorAll('[data-film-open]').forEach((button) => button.addEventListener('click',() => {
      if (!filmDialog || !filmPlayer || !button.dataset.filmSrc) return;
      filmPlayer.src = button.dataset.filmSrc;
      filmPlayer.poster = button.dataset.filmPoster || '';
      filmDialog.showModal();
      filmPlayer.play().catch(() => {});
    }));
    filmClose?.addEventListener('click',closeFilm);
    filmDialog?.addEventListener('click',(event) => { if (event.target === filmDialog) closeFilm(); });
    filmDialog?.addEventListener('cancel',(event) => { event.preventDefault(); closeFilm(); });

    const fragmentDialog = root.querySelector('[data-fragment-dialog]');
    const fragmentImage = root.querySelector('[data-fragment-image]');
    const fragmentCopy = root.querySelector('[data-fragment-copy]');
    const closeFragment = () => fragmentDialog?.close();
    root.querySelectorAll('[data-fragment-open]').forEach((button) => button.addEventListener('click',() => {
      if (!fragmentDialog || !fragmentImage) return;
      fragmentImage.src = button.dataset.fragmentSrc || '';
      fragmentImage.alt = button.dataset.fragmentCaption || 'Fragment de la Maison OrienX';
      if (fragmentCopy) fragmentCopy.textContent = button.dataset.fragmentCaption || '';
      fragmentDialog.showModal();
    }));
    root.querySelector('[data-fragment-close]')?.addEventListener('click',closeFragment);
    fragmentDialog?.addEventListener('click',(event) => { if (event.target === fragmentDialog) closeFragment(); });
    fragmentDialog?.addEventListener('cancel',(event) => { event.preventDefault(); closeFragment(); });

    if (!reduced && window.matchMedia('(pointer:fine)').matches) {
      const magnetic = root.querySelector('[data-maison-magnetic]');
      magnetic?.addEventListener('pointermove',(event) => {
        const rect = magnetic.getBoundingClientRect();
        magnetic.style.setProperty('--mag-x',`${(event.clientX - rect.left - rect.width / 2) / 9}px`);
        magnetic.style.setProperty('--mag-y',`${(event.clientY - rect.top - rect.height / 2) / 9}px`);
      });
      magnetic?.addEventListener('pointerleave',() => {
        magnetic.style.setProperty('--mag-x','0px');
        magnetic.style.setProperty('--mag-y','0px');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ox-header]');
    if (!root || root.dataset.ready === 'true') return;
    window.__orienxHeaderCleanup?.();
    root.dataset.ready = 'true';

    const events = new AbortController();
    const { signal } = events;
    const triggers = root.querySelectorAll('[data-ox-menu-trigger]');
    const panels = root.querySelectorAll('[data-ox-menu]');
    const localization = root.querySelector('[data-ox-localization]');
    const localizationSummary = localization?.querySelector('summary');
    const mobileToggle = root.querySelector('[data-ox-mobile-toggle]');
    const mobileMenu = root.querySelector('[data-ox-mobile-menu]');
    const search = root.querySelector('[data-ox-search-dialog]');
    const supportsZoneObserver = 'IntersectionObserver' in window;
    let zones = [];
    let zoneObserver = null;
    let surfaceFrame = 0;

    const validTone = (value) => value === 'light' || value === 'dark';
    const getHeaderProbeY = () => Math.max(0, Math.min(root.offsetHeight - 1, window.innerHeight - 1));
    const getActiveHeaderZone = () => {
      const probeY = getHeaderProbeY();
      return zones.find((zone) => {
        const rect = zone.getBoundingClientRect();
        return rect.top <= probeY && rect.bottom > probeY && validTone(zone.dataset.oxHeaderTone);
      });
    };
    const hasOpenOverlay = () =>
      [...panels].some((panel) => !panel.hidden) ||
      Boolean(mobileMenu && !mobileMenu.hidden) ||
      Boolean(search?.open) ||
      Boolean(localization?.open) ||
      document.documentElement.classList.contains('ox-cart-open');
    const applyHeaderSurface = () => {
      const overlayOpen = hasOpenOverlay();
      const activeZone = supportsZoneObserver && !overlayOpen ? getActiveHeaderZone() : null;
      root.classList.remove('is-solid','is-transparent','is-tone-light','is-tone-dark');
      root.classList.toggle('is-overlay-open', overlayOpen);
      root.classList.toggle('is-scrolled', window.scrollY > 16);
      if (!activeZone) {
        root.classList.add('is-solid');
        return;
      }
      root.classList.add('is-transparent', `is-tone-${activeZone.dataset.oxHeaderTone}`);
    };
    const scheduleHeaderSurface = () => {
      if (surfaceFrame) return;
      surfaceFrame = requestAnimationFrame(() => {
        surfaceFrame = 0;
        applyHeaderSurface();
      });
    };
    const setSurfacePreview = (active) => {
      root.classList.toggle('is-surface-preview', active);
    };
    const refreshHeaderZones = () => {
      zoneObserver?.disconnect();
      zones = supportsZoneObserver
        ? [...document.querySelectorAll('[data-ox-header-zone="transparent"]')].filter((zone) => validTone(zone.dataset.oxHeaderTone))
        : [];
      if (supportsZoneObserver) {
        zoneObserver = new IntersectionObserver(scheduleHeaderSurface);
        zones.forEach((zone) => zoneObserver.observe(zone));
      }
      scheduleHeaderSurface();
    };

    const showMegaChildren = (panel, key) => {
      if (!panel || !key) return;
      panel.querySelectorAll('[data-ox-mega-children]').forEach((group) => {
        group.hidden = group.dataset.oxMegaChildren !== key;
      });
      panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => {
        target.setAttribute('aria-expanded', String(target.dataset.oxMegaTarget === key));
      });
    };
    panels.forEach((panel) => {
      panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => {
        const reveal = () => showMegaChildren(panel, target.dataset.oxMegaTarget);
        target.addEventListener('pointerenter', reveal, { signal });
        target.addEventListener('focus', reveal, { signal });
      });
    });
    const closeMega = () => {
      panels.forEach((panel) => {
        panel.hidden = true;
        panel.querySelectorAll('[data-ox-mega-children]').forEach((group) => group.hidden = true);
        panel.querySelectorAll('[data-ox-mega-target]').forEach((target) => target.setAttribute('aria-expanded', 'false'));
      });
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded','false'));
      scheduleHeaderSurface();
    };
    triggers.forEach((trigger) => trigger.addEventListener('click', () => {
      const panel = root.querySelector(`[data-ox-menu="${trigger.dataset.oxMenuTrigger}"]`);
      const opening = panel?.hidden;
      closeMega();
      if (opening && panel) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded','true');
      }
      scheduleHeaderSurface();
    }, { signal }));
    const closeLocalization = () => {
      localization?.removeAttribute('open');
      scheduleHeaderSurface();
    };
    localization?.addEventListener('toggle', () => {
      localizationSummary?.setAttribute('aria-expanded', String(localization.open));
      scheduleHeaderSurface();
    }, { signal });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMega();
        closeLocalization();
      }
    }, { signal });
    root.addEventListener('pointerenter', () => setSurfacePreview(true), { signal });
    root.addEventListener('pointerleave', () => setSurfacePreview(false), { signal });
    root.addEventListener('focusin', () => setSurfacePreview(true), { signal });
    root.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!root.contains(document.activeElement)) setSurfacePreview(false);
      });
    }, { signal });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeMega();
      if (localization && !localization.contains(event.target)) closeLocalization();
    }, { signal });

    mobileToggle?.addEventListener('click', () => {
      const opening = mobileMenu.hidden;
      mobileMenu.hidden = !opening;
      mobileToggle.setAttribute('aria-expanded', String(opening));
      const label = mobileToggle.querySelector('span');
      if (label) label.textContent = opening ? 'Fermer' : 'Menu';
      document.documentElement.classList.toggle('ox-menu-open', opening);
      scheduleHeaderSurface();
    }, { signal });

    root.querySelector('[data-ox-search-open]')?.addEventListener('click', () => {
      search?.showModal();
      search?.querySelector('input[type="search"]')?.focus();
      scheduleHeaderSurface();
    }, { signal });
    root.querySelector('[data-ox-search-close]')?.addEventListener('click', () => {
      search?.close();
      scheduleHeaderSurface();
    }, { signal });
    search?.addEventListener('click', (event) => {
      if (event.target === search) search.close();
      scheduleHeaderSurface();
    }, { signal });
    search?.addEventListener('close', scheduleHeaderSurface, { signal });

    window.addEventListener('scroll', scheduleHeaderSurface, { passive: true, signal });
    window.addEventListener('resize', refreshHeaderZones, { passive: true, signal });
    window.addEventListener('load', scheduleHeaderSurface, { once: true, signal });
    document.addEventListener('shopify:section:load', refreshHeaderZones, { signal });
    document.addEventListener('ox:cart-toggle', scheduleHeaderSurface, { signal });
    window.__orienxHeaderCleanup = () => {
      events.abort();
      zoneObserver?.disconnect();
      if (surfaceFrame) cancelAnimationFrame(surfaceFrame);
    };
    refreshHeaderZones();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-selected-pieces"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const init=(root)=>{
      if(!root||root.dataset.oxSelectedReady==='true')return;
      root.dataset.oxSelectedReady='true';
      const viewport=root.querySelector('[data-ox-selected-viewport]');
      const track=root.querySelector('[data-ox-selected-track]');
      const previous=root.querySelector('[data-ox-selected-prev]');
      const next=root.querySelector('[data-ox-selected-next]');
      const status=root.querySelector('[data-ox-selected-status]');
      const cards=[...root.querySelectorAll('[data-ox-selected-card]')];
      if(!viewport||!track||cards.length<2)return;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const cloneCount=Math.min(3,cards.length);
      cards.slice(0,cloneCount).forEach(card=>{
        const clone=card.cloneNode(true);
        clone.dataset.oxSelectedClone='true';
        clone.removeAttribute('data-ox-selected-card');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden','true');
        if(clone.matches('a,button,[tabindex]'))clone.setAttribute('tabindex','-1');
        clone.querySelectorAll('a,button,[tabindex]').forEach(node=>node.setAttribute('tabindex','-1'));
        track.appendChild(clone);
      });
      let timer=0;
      let scrollFrame=0;
      let settleTimer=0;
      let targetIndex=null;
      let dragging=false;
      let dragged=false;
      let dragStartX=0;
      let dragStartScroll=0;
      let dragPointerId=null;
      const dragThreshold=10;
      const step=()=>{
        const gap=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0;
        return cards[0].getBoundingClientRect().width+gap;
      };
      const updateStatus=()=>{
        const distance=step();
        const active=distance?Math.round(viewport.scrollLeft/distance)%cards.length:0;
        if(status)status.textContent=`${String(active+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
      };
      const normalize=()=>{
        const distance=step();
        updateStatus();
        window.clearTimeout(settleTimer);
        settleTimer=window.setTimeout(()=>{
          if(distance&&viewport.scrollLeft>=cards.length*distance-1){
            viewport.scrollTo({left:0,behavior:'auto'});
          }
          targetIndex=null;
          updateStatus();
        },180);
      };
      const move=(direction)=>{
        const distance=step();
        if(!distance)return;
        let current=targetIndex===null?Math.round(viewport.scrollLeft/distance):targetIndex;
        if(current>=cards.length){
          viewport.scrollTo({left:0,behavior:'auto'});
          current=0;
        }
        let target=current+direction;
        if(target<0){
          viewport.scrollTo({left:cards.length*distance,behavior:'auto'});
          target=cards.length-1;
        }
        targetIndex=target;
        viewport.scrollTo({left:target*distance,behavior:reduced?'auto':'smooth'});
      };
      const stopAutoplay=()=>{if(timer){window.clearInterval(timer);timer=0}};
      const startAutoplay=()=>{
        stopAutoplay();
        if(reduced||document.hidden)return;
        timer=window.setInterval(()=>move(1),4200);
      };
      previous?.addEventListener('click',()=>{stopAutoplay();move(-1);startAutoplay()});
      next?.addEventListener('click',()=>{stopAutoplay();move(1);startAutoplay()});
      const releasePointerFocus=button=>{
        button?.addEventListener('pointerup',()=>button.blur());
        button?.addEventListener('pointercancel',()=>button.blur());
      };
      releasePointerFocus(previous);
      releasePointerFocus(next);
      root.addEventListener('focusin',stopAutoplay);
      root.addEventListener('focusout',event=>{if(!root.contains(event.relatedTarget))startAutoplay()});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)stopAutoplay();else startAutoplay()});
      viewport.addEventListener('scroll',()=>{
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame=window.requestAnimationFrame(normalize);
      },{passive:true});
      viewport.addEventListener('pointerdown',event=>{
        stopAutoplay();
        dragged=false;
        if(event.pointerType!=='mouse'||event.button!==0)return;
        dragging=true;
        dragPointerId=event.pointerId;
        dragStartX=event.clientX;
        dragStartScroll=viewport.scrollLeft;
      });
      viewport.addEventListener('pointermove',event=>{
        if(!dragging)return;
        const delta=event.clientX-dragStartX;
        if(Math.abs(delta)<dragThreshold)return;
        if(!dragged){dragged=true;viewport.setPointerCapture?.(event.pointerId)}
        viewport.scrollLeft=dragStartScroll-delta;
      });
      const finishDrag=()=>{
        if(dragPointerId!==null&&viewport.hasPointerCapture?.(dragPointerId))viewport.releasePointerCapture?.(dragPointerId);
        dragging=false;
        dragPointerId=null;
        startAutoplay();
      };
      viewport.addEventListener('pointerup',finishDrag);
      viewport.addEventListener('pointercancel',finishDrag);
      viewport.addEventListener('click',event=>{if(dragged){event.preventDefault();event.stopPropagation();dragged=false}},true);
      if(!reduced&&'IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting&&entry.intersectionRatio>=.12){root.classList.add('is-visible');startAutoplay();return}if(entry.isIntersecting)return;root.classList.remove('is-visible');if(entry.boundingClientRect.bottom<=0)root.style.setProperty('--ox-selected-reveal-y','-26px');else if(entry.boundingClientRect.top>=window.innerHeight)root.style.setProperty('--ox-selected-reveal-y','26px');stopAutoplay()})},{threshold:[0,.12],rootMargin:'0px'});observer.observe(root)}else{root.classList.add('is-visible');startAutoplay()}
      if(!reduced&&window.matchMedia('(pointer:fine)').matches){cards.forEach(card=>{card.addEventListener('pointermove',event=>{const r=card.getBoundingClientRect();const x=(event.clientX-r.left)/r.width-.5;const y=(event.clientY-r.top)/r.height-.5;card.style.setProperty('--ox-card-x',`${x*-7}px`);card.style.setProperty('--ox-card-y',`${y*-7}px`)});card.addEventListener('pointerleave',()=>{card.style.setProperty('--ox-card-x','0px');card.style.setProperty('--ox-card-y','0px')})})}
      updateStatus();
    };
    const initAll=(scope=document)=>{scope.querySelectorAll?.('[data-ox-selected-pieces]').forEach(init);if(scope.matches?.('[data-ox-selected-pieces]'))init(scope)};
    initAll();document.addEventListener('shopify:section:load',event=>initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orienx-stories-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const root=document.querySelector('[data-ox-stories]');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals=root.querySelectorAll('[data-story-reveal]');
    if(!reduced&&'IntersectionObserver'in window){
      root.classList.add('ox-story-motion');
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');observer.unobserve(entry.target)}),{threshold:.08,rootMargin:'0px 0px -5%'});
      reveals.forEach(item=>observer.observe(item));
    }else reveals.forEach(item=>item.classList.add('is-visible'));
    const dialog=root.querySelector('[data-story-dialog]');
    const player=root.querySelector('[data-story-player]');
    const close=()=>{player?.pause();dialog?.close()};
    root.querySelectorAll('[data-story-open]').forEach(button=>button.addEventListener('click',()=>{if(!dialog||!player||!button.dataset.storySrc)return;player.src=button.dataset.storySrc;player.poster=button.dataset.storyPoster||'';dialog.showModal();player.play().catch(()=>{})}));
    root.querySelector('[data-story-close]')?.addEventListener('click',close);
    dialog?.addEventListener('click',event=>{if(event.target===dialog)close()});
    dialog?.addEventListener('cancel',event=>{event.preventDefault();close()});
  })();

  } catch(e) { console.error(e); }
})();
})();
